// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2jLMY","head":"Table_head__25tAg","col":"Table_col__SE4E3"};